import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 60px;
`;

export const FormContainer = styled.form``;
